import { useParams } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";
import { findProvider, games } from "@/data/providers";
import { listCasinos } from "@/data/casinos";
import { CasinoCard } from "@/components/CasinoCard";
import { NotFoundPage } from "./NotFoundPage";
import { Link } from "react-router-dom";
import { slotPath } from "@/lib/format";

export function ProviderPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const provider = findProvider(slug);
  if (!provider) return <NotFoundPage />;
  const providerGames = games.filter((g) => g.provider_slug === slug);
  const casinos = listCasinos({ provider: slug });

  return (
    <div className="container-page py-8">
      <SEO
        title={`${provider.name} – ${isSv ? "speltillverkare" : "software provider"}`}
        description={isSv ? provider.description_sv : provider.description_en}
      />
      <Breadcrumbs
        items={[
          { label: t("nav.home"), href: prefix },
          {
            label: isSv ? "Speltillverkare" : "Software providers",
            href: `${prefix}/${isSv ? "speltillverkare" : "software-providers"}`,
          },
          { label: provider.name },
        ]}
      />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{provider.name}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">
        {isSv ? provider.description_sv : provider.description_en}
      </p>

      {providerGames.length > 0 && (
        <section className="mt-6">
          <h2 className="text-2xl font-bold">{isSv ? "Populära spel" : "Popular games"}</h2>
          <div className="mt-3 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
            {providerGames.map((g) => (
              <Link
                key={g.id}
                to={slotPath(prefix, lang, g.slug)}
                className="card no-underline p-4 transition hover:shadow-md"
              >
                <h3 className="font-semibold">{g.name}</h3>
                <p className="mt-1 text-sm text-ink-600">
                  {isSv ? g.description_sv : g.description_en}
                </p>
              </Link>
            ))}
          </div>
        </section>
      )}

      <h2 className="mt-8 text-2xl font-bold">
        {isSv ? `Casinon med ${provider.name}` : `Casinos with ${provider.name}`}
      </h2>
      <div className="mt-4 grid gap-4">
        {casinos.map((c, i) => (
          <CasinoCard key={c.id} casino={c} rank={i + 1} source={`provider-${slug}`} />
        ))}
      </div>

      <InternalLinks context="provider" />
    </div>
  );
}
